module.exports = __webpack_public_path__ + "img/12-ABITO-ANTIBE-SML-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.fe7ec78e.jpg";